import z from "zod";
import { looseUuid } from "@thalamos/common";
export const LondonCareRecordConfigIdSchema = looseUuid().brand();
export const LondonCareRecordConfigSchema = z
    .object({
    id: LondonCareRecordConfigIdSchema,
    name: z.string().min(1).max(255),
    expectedServerCommonName: z.string().min(1).max(255).nullable(),
    ca: z.string().min(1).nullable(),
    key: z.string().min(1).nullable(),
    cert: z.string().min(1).nullable(),
    host: z.string().min(1).max(255),
    port: z.number().int().positive(),
    sslEnabled: z.boolean(),
    urlPath: z.string().min(1).max(255).nullable(),
    isTest: z.boolean(),
})
    .brand();
//# sourceMappingURL=londonCareRecordInstance.js.map